import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function PaginationCard ({ page, pages, changePage }) {

	return (
		<div className="flex items-center justify-center gap-2 mt-10" data-testid="pagination">
			<Button disabled={page <= 1} onClick={() => changePage(page - 1)}
							variant="outline" className="border-[#E6E2D6] rounded-sm h-10 w-10 p-0">
				<ChevronLeft className="w-4 h-4" />
			</Button>
			{[...Array(Math.min(pages, 5))].map((_, i) => {
				const p = i + 1;
				return (
					<Button key={p} onClick={() => changePage(p)} variant={p === page ? 'default' : 'outline'}
							className={`rounded-sm h-10 w-10 p-0 ${p === page ? 'bg-[#1A3C34] text-white' : 'border-[#E6E2D6]'}`}>
						{p}
					</Button>
				);
			})}
			<Button disabled={page >= pages} onClick={() => changePage(page + 1)}
							variant="outline" className="border-[#E6E2D6] rounded-sm h-10 w-10 p-0">
				<ChevronRight className="w-4 h-4" />
			</Button>
		</div>
	);
};